import { useState } from "react";
import Modal from "../components/modal/Modal";
import AboutUs from "./about-us/AboutUs";
import Banner from "./banner/Banner";
import CallToAction from "./calltoaction/CallToAction";
import Experiences from "./experiences/Experiences";
import GalleryOverlay from "./gallery/GalleryOverlay";
import GetInTouch from "./getintouch/GetInTouch";

export default function Home() {
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  return(
    <>
      <Banner/>
      <AboutUs openModal={openModal}/>
      <CallToAction/>
      <Experiences  openModal={openModal}/>
      <GalleryOverlay  openModal={openModal}/>
      <GetInTouch openModal={openModal} />
      <Modal isOpen={isModalOpen} onClose={closeModal} />
    </>
  )
}